export default __webpack_public_path__ + "static/media/vire14.3144a499.jpg";